import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rk-share-page-wrapper',
  template: ` <div class="content"><ng-content></ng-content></div> `,
  styles: [
    `
      .content {
        padding: 20px 25px 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharePageWrapperComponent {}
